require('./bootstrap');
require('./../../node_modules/daterangepicker');
require('./../../node_modules/chart.js/dist/Chart.bundle.min.js')

$(document).ready(function() {
    try {
        moment.locale('pt-br');
        $("#dashboardDialog").modal({show: false});
    } catch (e) {}
});
